import { useMemo } from "react";

import { useTrack } from "pro-features/components/WithTrack/src/useTrack";

import { createTeamsTrackingService } from "../services/tracking/factory";

export const useTeamsTrackingService = () => {
    const [track] = useTrack();

    return useMemo(() => createTeamsTrackingService(track), [track]);
};
